"use client";

import { SlidersHorizontal } from "lucide-react";
import { type ReactNode, useState } from "react";
import { Button } from "@/components/ui/button";

/** The filter bar of a list folded away: the search box with a "Filters" button and the submit button on one row, the choices (children) under it shown only after the button is pressed (or from the start when `open`, because one is set). The choices stay in the form while folded, so a search keeps them. */
export function FiltersPanel({ search, submit, label, open = false, children }: { search: ReactNode; submit: ReactNode; label: string; open?: boolean; children: ReactNode }) {
  const [shown, setShown] = useState(open);
  return (
    <>
      <div className="flex flex-wrap items-end gap-2">
        {search}
        <Button type="button" variant="outline" aria-expanded={shown} onClick={() => setShown(!shown)}><SlidersHorizontal />{label}</Button>
        {submit}
      </div>
      <div hidden={!shown} className="flex flex-col gap-2">{children}</div>
    </>
  );
}
